import { createAsyncThunk } from '@reduxjs/toolkit';

import { OrdersHttpGetService } from 'Feature/Common/Common/Services/OrderHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

export const getCartItemsTotalCountByCurrentUser = createAsyncThunk(
  'Order/getCartItemsTotalCountByCurrentUser',
  async () => {
    return await OrdersHttpGetService({
      url: `${_apiPathManagerConfig?.Orders.Order.GetCartItemsTotalCountByCurrentUser}`,
    });
  }
);
